export default langsData => [
  {
    path: "/signup_h5",
    name: "signup_h5",
    component: () =>
      import(
        /* webpackChunkName: "signup_h5" */ "@/views/passport/signup_h5/index.vue"
      ),
    baseWidth: "360",
    meta: {
      title: langsData["signup_h5"].title
    }
  }
];
